import { useAuth0 } from '@auth0/auth0-react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';

import { PATHS } from '../routes/paths';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  const { isAuthenticated } = useAuth0();

  if (isAuthenticated) {
    return <Navigate to={PATHS.dashboard} />;
  }

  return <>{children}</>;
}

GuestGuard.propTypes = {
  children: PropTypes.node
};
